// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* v1.0.1 Custom CSS - Do Not Modify Classes w/out Notice */
/* Client / Portal Specific Changes Go in Dedicated Area */

/* Client / Portal Specific Changes Go in Dedicated Area */

/* SETUP - Portal Color Variables - START */
:root {
  --mf-primary-color: #012979;
  --mf-secondary-color: #212153;
  --mf-accent-color: #056d82;
  --mf-white: #ffffff;
  --mf-black: #000000;
  --bradius: 4px;
}
/* SETUP - Portal Color Variables - END */

/*.nav-search {
	visibility: hidden;
}
*/

/* CORE MF THEME - START */
/*
.navbar-location {
	margin-top: 0px;
} 
*/
/* MENU - START */
/* Menu Bar Background */
.iron-header-v1 .iron-header-bottom {
  background-color: var(--mf-primary-color) !important;
}

/* Menu Bar Font Color */
.iron-header-v1 .iron-header-menu li a {
  color: var(--mf-white) !important;
}

/* Menu Bar on Hover */
.iron-header-v1 .iron-header-menu li a:hover {
  background-color: var(--mf-secondary-color) !important;
  color: var(--mf-white) !important;
}

/* Menu Bar Bottom Accent Color on Hover */
.iron-header-menu li a:after {
  background: var(--mf-secondary-color) !important;
}

/* Sticky Menu Bar Background */
.iron-fixed-header {
  background-color: var(--mf-primary-color) !important;
}

/* Mobile Menu Background */
.sidebar-area > div:nth-child(2) {
  background-color: var(--mf-primary-color) !important;
}

/* FIX - Mobile Menu Background Coverage */
.jss69 {
  left: 0 !important;
  right: 30% !important;
}
/* MENU - END */

/* FIX - Center Image on Register Page */
.register-image {
  background-position: center !important;
}

/* FIX Hide Page Header Text */
.page-title-bar * {
  color: #fff0;
}

/* Product Card Icon Background Color */
.iron-product-item .iron-btn-grp .btn-wrap {
  background-color: var(--mf-secondary-color) !important;
}

/* My Account > My Orders - Show Details Button */
.btn-active {
  background-color: var(--mf-primary-color);
}

/* My Account > My Orders > Show Details > Card Header Background Color */
.card-header {
  background-color: var(--mf-primary-color) !important;
}

/* Product Page - Add to Cart Modal 'Ok Button' Background Color */
.sweet-alert .btn-warning {
  background-color: var(--mf-primary-color);
}

/* Cart Icon Qty Background */
.badge-active span {
  background-color: var(--mf-accent-color) !important;
}

/* Cart Icon Background */
.icon-btn {
  background-color: var(--mf-primary-color) !important;
  border-radius: var(--bradius);
}

/* Cart Icon Background on Hover */
.icon-btn:hover {
  background-color: var(--mf-accent-color) !important;
}

/* Hyperlinks */
a {
  color: var(--mf-accent-color) !important;
  outline: none !important;
}

a:hover,
a:focus {
  color: var(--mf-secondary-color) !important;
}
/* Hyperlinks END */

/* Contact Page Icon Background */
.contact-icon {
  background: var(--mf-primary-color) !important;
}

/* Product Title on Category Card */
.d-block {
  color: var(--mf-primary-color) !important;
}

/* Pre-Header - Background Color */
.iron-header-v1 .top-links-container {
  background-color: var(--mf-white) !important;
}

/* Header - Background Color */
.iron-header-v1 .iron-header-top {
  background-color: var(--mf-white) !important;
}

/* Cart Icon Dropdown - List Item Icons */
.iron-cart-list-wrap .cart-menu-item .cart-content-wrap .cart-edit-action .button.icon-btn {
  background-color: var(--mf-accent-color) !important;
}

/* My Account > Account Dashboard - View All Link Color */
.iron-dashboard-page-wrap .recent-orders-wrap .recent-orders-wrap-header a {
  color: var(--mf-accent-color) !important;
}

/* My Account > My Address Book - New Address Button */
.add-address-btn {
  background: var(--mf-accent-color) !important;
}

/* Checkout - Payment Text */
.payment-total {
  color: var(--mf-accent-color) !important;
}

/* Checkout Page Buttons - Place Your Order */
.checkout-btn button,
.basket-checkout-btn .btn-active {
  background-color: var(--mf-secondary-color) !important;
}

.checkout-btn > button > span {
  color: var(--mf-white) !important;
}
/* Checkout Page Buttons - Place Your Order - END */

/* Page Content - Feature - Icon Background Color */
.iron-features-v2 .iron-feature-icon span {
  background-color: var(--mf-accent-color) !important;
}

/* Page Content - ProductSlider - Price Color */
.iron-product-item .price-wrap span {
  color: var(--mf-accent-color) !important;
}

/* Page Content - ProductSlider - Category Title Font Color */
.product-slider .product-slider-selected-category {
  color: var(--mf-accent-color) !important;
}

/* Trash Icon on Cart Page */
.iron-cart-wrapper .cart-btn i {
  color: var(--mf-accent-color) !important;
}

/* Product Price Color on Category Card */
.product-info-theme {
  color: var(--mf-primary-color) !important;
}

/* Co-Op Title & Price Color on Product Page */
.active-color {
  color: var(--mf-accent-color) !important;
}

/* Buttons */
.button {
  background-color: var(--mf-primary-color) !important;
}

/* Modal Save Button */
.btn-success {
  background-color: var(--mf-primary-color) !important;
  border-color: var(--mf-secondary-color) !important;
  color: var(--mf-white) !important;
}

.btn-success:hover {
  background-color: var(--mf-primary-color) !important;
  border-color: var(--mf-primary-color) !important;
  color: var(--mf-white) !important;
}

/* Checkout - Add Address Button */
.btn-primary {
  background-color: var(--mf-primary-color);
  border-color: var(--mf-primary-color);
  color: var(--mf-white);
}

.btn-primary:hover {
  background-color: transparent;
  border-color: var(--mf-primary-color);
  color: var(--mf-primary-color);
}
/* Checkout - Add Address Button - END */

/* Modal Close Button */
.btn-danger {
  background-color: var(--mf-accent-color);
  border-color: var(--mf-secondary-color);
  color: var(--mf-white);
}

.btn-danger:hover {
  background-color: var(--mf-accent-color);
  border-color: var(--mf-primary-color);
  color: var(--mf-white);
}
/* Modal Close Button - END */

/* FIX - Qty Box Width on FF */
.increment-quantity {
  width: -moz-fit-content !important;
}

/* Footer Background Color and Padding Adjustment */
.iron-footer-v1 .iron-footer-top {
  background-color: var(--mf-primary-color) !important;
  padding-top: 2.75rem !important;
}

/* FIX - Fat Image Styling */
.iron-cta-item.custom-cta {
  border-radius: 7px !important;
  transition: 0.4s ease-in-out !important;
}

.iron-cta-item.custom-cta:hover {
  box-shadow:
    0 0 5px 0 rgba(0, 0, 0, 0.12),
    0 7px 9px 0 rgba(0, 0, 0, 0.24) !important;
}
/* FIX - Fat Image Styling - END */

/* FIX - Portal Logo Scale */
.iron-app-logo > a > img {
  /* width: 174px !important;
  max-width: max-content !important; */
}

/* Depreciated CSS - Old Side Search / Filters */
.filter-container {
  box-shadow:
    0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 2px 1px -1px rgba(0, 0, 0, 0.12) !important;
  background-color: var(--mf-white) E0 !important;
  border-radius: 6px !important;
}

/* FIX - Category Card Rounded Edges */
.jss21 {
  border-radius: 8px !important;
}

/* Pagination Indicator Color */
.smart-pager .smart-pager-page-index-selector[selected] {
  background-color: var(--mf-secondary-color) !important;
}

/* Filter Accordian Qty Count Colors */
.badge-secondary {
  background-color: var(--mf-accent-color) !important;
  color: var(--mf-white) !important;
  border-radius: var(--bradius);
}

/* Custom Tag Set CSS */
.product-page-red-block {
  height: 50px;
  width: 50px;
  background: red;
  position: absolute;
  right: 0;
}

.product-page-blue-block {
  height: 50px;
  width: 50px;
  background: blue;
  position: absolute;
  left: 0;
}

/* CORE MF THEME - END */

/* PORTAL CSS */
/* Client Specific CSS Adjustments Go Here */

.page-title-bar {
  padding: 0rem 0 !important;
}

.app-container > div:nth-child(2) {
  background: #f5f5f5;
}

/* Client Specific CSS Adjustments - END */
/* PORTAL CSS - END */

/* v1.0.1 Custom CSS - Do Not Modify Classes w/out Notice */
/* Client / Portal Specific Changes Go in Dedicated Area */
`, "",{"version":3,"sources":["webpack://./src/assets/scss/sample_portal_css.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D,0DAA0D;;AAE1D,0DAA0D;;AAE1D,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,yCAAyC;;AAEzC;;;CAGC;;AAED,0BAA0B;AAC1B;;;;CAIC;AACD,iBAAiB;AACjB,wBAAwB;AACxB;EACE,oDAAoD;AACtD;;AAEA,wBAAwB;AACxB;EACE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,sDAAsD;EACtD,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;EACE,oDAAoD;AACtD;;AAEA,2BAA2B;AAC3B;EACE,oDAAoD;AACtD;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA,eAAe;;AAEf,wCAAwC;AACxC;EACE,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,sDAAsD;AACxD;;AAEA,iDAAiD;AACjD;EACE,yCAAyC;AAC3C;;AAEA,yEAAyE;AACzE;EACE,oDAAoD;AACtD;;AAEA,kEAAkE;AAClE;EACE,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,mDAAmD;AACrD;;AAEA,yBAAyB;AACzB;EACE,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,mDAAmD;AACrD;;AAEA,eAAe;AACf;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;;EAEE,2CAA2C;AAC7C;AACA,mBAAmB;;AAEnB,iCAAiC;AACjC;EACE,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,4CAA4C;AAC9C;;AAEA,yCAAyC;AACzC;EACE,mDAAmD;AACrD;;AAEA,yDAAyD;AACzD;EACE,wCAAwC;AAC1C;;AAEA,sDAAsD;AACtD;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;;EAEE,sDAAsD;AACxD;;AAEA;EACE,iCAAiC;AACnC;AACA,mDAAmD;;AAEnD,mDAAmD;AACnD;EACE,mDAAmD;AACrD;;AAEA,+CAA+C;AAC/C;EACE,wCAAwC;AAC1C;;AAEA,6DAA6D;AAC7D;EACE,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,oDAAoD;AACtD;;AAEA,sBAAsB;AACtB;EACE,oDAAoD;EACpD,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE,yCAAyC;EACzC,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;AAChC;AACA,wCAAwC;;AAExC,uBAAuB;AACvB;EACE,wCAAwC;EACxC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;AACxB;AACA,6BAA6B;;AAE7B,8BAA8B;AAC9B;EACE,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;EACE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE;;8CAE4C;AAC9C;AACA,kCAAkC;;AAElC,4BAA4B;AAC5B;EACE;sCACoC;AACtC;;AAEA,gDAAgD;AAChD;EACE;;;mDAGiD;EACjD,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,sDAAsD;AACxD;;AAEA,sCAAsC;AACtC;EACE,mDAAmD;EACnD,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA,wBAAwB;;AAExB,eAAe;AACf,4CAA4C;;AAE5C;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C,qBAAqB;;AAErB,2DAA2D;AAC3D,0DAA0D","sourcesContent":["/* v1.0.1 Custom CSS - Do Not Modify Classes w/out Notice */\n/* Client / Portal Specific Changes Go in Dedicated Area */\n\n/* Client / Portal Specific Changes Go in Dedicated Area */\n\n/* SETUP - Portal Color Variables - START */\n:root {\n  --mf-primary-color: #012979;\n  --mf-secondary-color: #212153;\n  --mf-accent-color: #056d82;\n  --mf-white: #ffffff;\n  --mf-black: #000000;\n  --bradius: 4px;\n}\n/* SETUP - Portal Color Variables - END */\n\n/*.nav-search {\n\tvisibility: hidden;\n}\n*/\n\n/* CORE MF THEME - START */\n/*\n.navbar-location {\n\tmargin-top: 0px;\n} \n*/\n/* MENU - START */\n/* Menu Bar Background */\n.iron-header-v1 .iron-header-bottom {\n  background-color: var(--mf-primary-color) !important;\n}\n\n/* Menu Bar Font Color */\n.iron-header-v1 .iron-header-menu li a {\n  color: var(--mf-white) !important;\n}\n\n/* Menu Bar on Hover */\n.iron-header-v1 .iron-header-menu li a:hover {\n  background-color: var(--mf-secondary-color) !important;\n  color: var(--mf-white) !important;\n}\n\n/* Menu Bar Bottom Accent Color on Hover */\n.iron-header-menu li a:after {\n  background: var(--mf-secondary-color) !important;\n}\n\n/* Sticky Menu Bar Background */\n.iron-fixed-header {\n  background-color: var(--mf-primary-color) !important;\n}\n\n/* Mobile Menu Background */\n.sidebar-area > div:nth-child(2) {\n  background-color: var(--mf-primary-color) !important;\n}\n\n/* FIX - Mobile Menu Background Coverage */\n.jss69 {\n  left: 0 !important;\n  right: 30% !important;\n}\n/* MENU - END */\n\n/* FIX - Center Image on Register Page */\n.register-image {\n  background-position: center !important;\n}\n\n/* FIX Hide Page Header Text */\n.page-title-bar * {\n  color: #fff0;\n}\n\n/* Product Card Icon Background Color */\n.iron-product-item .iron-btn-grp .btn-wrap {\n  background-color: var(--mf-secondary-color) !important;\n}\n\n/* My Account > My Orders - Show Details Button */\n.btn-active {\n  background-color: var(--mf-primary-color);\n}\n\n/* My Account > My Orders > Show Details > Card Header Background Color */\n.card-header {\n  background-color: var(--mf-primary-color) !important;\n}\n\n/* Product Page - Add to Cart Modal 'Ok Button' Background Color */\n.sweet-alert .btn-warning {\n  background-color: var(--mf-primary-color);\n}\n\n/* Cart Icon Qty Background */\n.badge-active span {\n  background-color: var(--mf-accent-color) !important;\n}\n\n/* Cart Icon Background */\n.icon-btn {\n  background-color: var(--mf-primary-color) !important;\n  border-radius: var(--bradius);\n}\n\n/* Cart Icon Background on Hover */\n.icon-btn:hover {\n  background-color: var(--mf-accent-color) !important;\n}\n\n/* Hyperlinks */\na {\n  color: var(--mf-accent-color) !important;\n  outline: none !important;\n}\n\na:hover,\na:focus {\n  color: var(--mf-secondary-color) !important;\n}\n/* Hyperlinks END */\n\n/* Contact Page Icon Background */\n.contact-icon {\n  background: var(--mf-primary-color) !important;\n}\n\n/* Product Title on Category Card */\n.d-block {\n  color: var(--mf-primary-color) !important;\n}\n\n/* Pre-Header - Background Color */\n.iron-header-v1 .top-links-container {\n  background-color: var(--mf-white) !important;\n}\n\n/* Header - Background Color */\n.iron-header-v1 .iron-header-top {\n  background-color: var(--mf-white) !important;\n}\n\n/* Cart Icon Dropdown - List Item Icons */\n.iron-cart-list-wrap .cart-menu-item .cart-content-wrap .cart-edit-action .button.icon-btn {\n  background-color: var(--mf-accent-color) !important;\n}\n\n/* My Account > Account Dashboard - View All Link Color */\n.iron-dashboard-page-wrap .recent-orders-wrap .recent-orders-wrap-header a {\n  color: var(--mf-accent-color) !important;\n}\n\n/* My Account > My Address Book - New Address Button */\n.add-address-btn {\n  background: var(--mf-accent-color) !important;\n}\n\n/* Checkout - Payment Text */\n.payment-total {\n  color: var(--mf-accent-color) !important;\n}\n\n/* Checkout Page Buttons - Place Your Order */\n.checkout-btn button,\n.basket-checkout-btn .btn-active {\n  background-color: var(--mf-secondary-color) !important;\n}\n\n.checkout-btn > button > span {\n  color: var(--mf-white) !important;\n}\n/* Checkout Page Buttons - Place Your Order - END */\n\n/* Page Content - Feature - Icon Background Color */\n.iron-features-v2 .iron-feature-icon span {\n  background-color: var(--mf-accent-color) !important;\n}\n\n/* Page Content - ProductSlider - Price Color */\n.iron-product-item .price-wrap span {\n  color: var(--mf-accent-color) !important;\n}\n\n/* Page Content - ProductSlider - Category Title Font Color */\n.product-slider .product-slider-selected-category {\n  color: var(--mf-accent-color) !important;\n}\n\n/* Trash Icon on Cart Page */\n.iron-cart-wrapper .cart-btn i {\n  color: var(--mf-accent-color) !important;\n}\n\n/* Product Price Color on Category Card */\n.product-info-theme {\n  color: var(--mf-primary-color) !important;\n}\n\n/* Co-Op Title & Price Color on Product Page */\n.active-color {\n  color: var(--mf-accent-color) !important;\n}\n\n/* Buttons */\n.button {\n  background-color: var(--mf-primary-color) !important;\n}\n\n/* Modal Save Button */\n.btn-success {\n  background-color: var(--mf-primary-color) !important;\n  border-color: var(--mf-secondary-color) !important;\n  color: var(--mf-white) !important;\n}\n\n.btn-success:hover {\n  background-color: var(--mf-primary-color) !important;\n  border-color: var(--mf-primary-color) !important;\n  color: var(--mf-white) !important;\n}\n\n/* Checkout - Add Address Button */\n.btn-primary {\n  background-color: var(--mf-primary-color);\n  border-color: var(--mf-primary-color);\n  color: var(--mf-white);\n}\n\n.btn-primary:hover {\n  background-color: transparent;\n  border-color: var(--mf-primary-color);\n  color: var(--mf-primary-color);\n}\n/* Checkout - Add Address Button - END */\n\n/* Modal Close Button */\n.btn-danger {\n  background-color: var(--mf-accent-color);\n  border-color: var(--mf-secondary-color);\n  color: var(--mf-white);\n}\n\n.btn-danger:hover {\n  background-color: var(--mf-accent-color);\n  border-color: var(--mf-primary-color);\n  color: var(--mf-white);\n}\n/* Modal Close Button - END */\n\n/* FIX - Qty Box Width on FF */\n.increment-quantity {\n  width: -moz-fit-content !important;\n}\n\n/* Footer Background Color and Padding Adjustment */\n.iron-footer-v1 .iron-footer-top {\n  background-color: var(--mf-primary-color) !important;\n  padding-top: 2.75rem !important;\n}\n\n/* FIX - Fat Image Styling */\n.iron-cta-item.custom-cta {\n  border-radius: 7px !important;\n  transition: 0.4s ease-in-out !important;\n}\n\n.iron-cta-item.custom-cta:hover {\n  box-shadow:\n    0 0 5px 0 rgba(0, 0, 0, 0.12),\n    0 7px 9px 0 rgba(0, 0, 0, 0.24) !important;\n}\n/* FIX - Fat Image Styling - END */\n\n/* FIX - Portal Logo Scale */\n.iron-app-logo > a > img {\n  /* width: 174px !important;\n  max-width: max-content !important; */\n}\n\n/* Depreciated CSS - Old Side Search / Filters */\n.filter-container {\n  box-shadow:\n    0px 1px 3px 0px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14),\n    0px 2px 1px -1px rgba(0, 0, 0, 0.12) !important;\n  background-color: var(--mf-white) E0 !important;\n  border-radius: 6px !important;\n}\n\n/* FIX - Category Card Rounded Edges */\n.jss21 {\n  border-radius: 8px !important;\n}\n\n/* Pagination Indicator Color */\n.smart-pager .smart-pager-page-index-selector[selected] {\n  background-color: var(--mf-secondary-color) !important;\n}\n\n/* Filter Accordian Qty Count Colors */\n.badge-secondary {\n  background-color: var(--mf-accent-color) !important;\n  color: var(--mf-white) !important;\n  border-radius: var(--bradius);\n}\n\n/* Custom Tag Set CSS */\n.product-page-red-block {\n  height: 50px;\n  width: 50px;\n  background: red;\n  position: absolute;\n  right: 0;\n}\n\n.product-page-blue-block {\n  height: 50px;\n  width: 50px;\n  background: blue;\n  position: absolute;\n  left: 0;\n}\n\n/* CORE MF THEME - END */\n\n/* PORTAL CSS */\n/* Client Specific CSS Adjustments Go Here */\n\n.page-title-bar {\n  padding: 0rem 0 !important;\n}\n\n.app-container > div:nth-child(2) {\n  background: #f5f5f5;\n}\n\n/* Client Specific CSS Adjustments - END */\n/* PORTAL CSS - END */\n\n/* v1.0.1 Custom CSS - Do Not Modify Classes w/out Notice */\n/* Client / Portal Specific Changes Go in Dedicated Area */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
